import axios2 from "@/hooks/axios/axios";
import type { CreatePulseProps } from "../types/pulse.types";

export const getPulse = async (apiToken: string) => {
  const headers = { "x-api-token": apiToken };
  const { data } = await axios2.get("/pulses?limit=100&page=1", { headers });
  return data;
};

export const getPulsePostData = async (postUrl: string, apiToken: string) => {
  const encodedUrl = encodeURIComponent(postUrl);
  const headers = { "x-api-token": apiToken };
  const { data } = await axios2.get(`/pulse/post/${encodedUrl}`, { headers });
  return data;
};

export const createPulse = async (
  createPulseProps: CreatePulseProps,
  apiToken: string,
) => {
  const params = new URLSearchParams({
    pulse_name: createPulseProps.pulse_name,
    post_url: createPulseProps.post_url,
    platform: createPulseProps.platform,
    max_wait_seconds: createPulseProps.max_wait_seconds.toString(),
  });

  const headers = { "x-api-token": apiToken };
  const { data } = await axios2.post(
    `/pulse?${params.toString()}`,
    {},
    { headers },
  );
  return data;
};

export const getPulseSnapshot = async (pulseId: string, apiToken: string) => {
  const headers = { "x-api-token": apiToken };
  const { data } = await axios2.get(`/pulse/snapshot/${pulseId}`, {
    headers,
  });
  return data;
};

export const deletePulse = async (pulseId: string, apiToken?: string) => {
  const headers = apiToken ? { "x-api-token": apiToken } : {};
  const { data } = await axios2.delete(`/pulse/${pulseId}`, { headers });
  return data;
};

export const updatePulse = async (pulseId: string, apiToken: string) => {
  const headers = {
    "Content-Type": "application/json",
    "x-api-token": apiToken,
  };
  const { data } = await axios2.put(
    `/pulse`,
    {},
    { headers, params: { pulse_id: pulseId } },
  );
  return data;
};
